import React from 'react';
import { Link } from 'react-router-dom';
import Hero from '../components/Hero';
import ServiceCard from '../components/ServiceCard';
import { Briefcase, Building, ShieldCheck, Globe } from 'lucide-react';
const Home = () => {
  return <div className="w-full" data-id="element-157">
      {/* Hero Section */}
      <Hero title="Boutique Legal Consultancy with Global Reach" subtitle="Combining the precision of top-tier legal advisory with the personalized approach of a boutique consultancy. Over a decade of expertise in guiding businesses through complex legal landscapes." showCta={true} data-id="element-158" />
      {/* About Snapshot */}
      <section className="py-16 md:py-24 bg-gray-50" data-id="element-159">
        <div className="container mx-auto px-4" data-id="element-160">
          <div className="max-w-3xl mx-auto text-center" data-id="element-161">
            <h2 className="text-3xl font-serif mb-6 text-[#1a2542]" data-id="element-162">
              Welcome to The Concierge Lawyering
            </h2>
            <p className="text-lg text-gray-700 mb-8 leading-relaxed" data-id="element-163">
              At The Concierge Lawyering, we combine the precision of top-tier
              legal advisory with the personalized approach of a boutique
              consultancy. Headquartered in Lagos, and with a growing
              international footprint, our team brings over a decade of
              experience in guiding businesses, entrepreneurs, and investors
              through complex legal and regulatory landscapes.
            </p>
            <Link to="/about" className="inline-block px-6 py-3 bg-[#1a2542] hover:bg-[#233055] text-white rounded-md transition-colors duration-300 font-medium" data-id="element-164">
              Learn More About Us
            </Link>
          </div>
        </div>
      </section>
      {/* Services Overview */}
      <section className="py-16 md:py-24" data-id="element-165">
        <div className="container mx-auto px-4" data-id="element-166">
          <div className="text-center mb-12" data-id="element-167">
            <h2 className="text-3xl font-serif mb-4 text-[#1a2542]" data-id="element-168">
              Our Services
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-169">
              We simplify the complexities of law so you can focus on building
              and growing with confidence.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-170">
            <ServiceCard title="Commercial Transactions" description="Supporting negotiations, drafting, and deal structuring to safeguard your interests." icon={<Briefcase size={32} data-id="element-172" />} data-id="element-171" />
            <ServiceCard title="Property Transactions" description="Managing acquisitions, leases, and transfers with clarity and security." icon={<Building size={32} data-id="element-174" />} data-id="element-173" />
            <ServiceCard title="Regulatory Compliance" description="Ensuring your business operates within the framework of local and international laws." icon={<ShieldCheck size={32} data-id="element-176" />} data-id="element-175" />
            <ServiceCard title="International Business" description="Guiding cross-border ventures, particularly into Qatar and beyond." icon={<Globe size={32} data-id="element-178" />} data-id="element-177" />
          </div>
          <div className="text-center mt-12" data-id="element-179">
            <Link to="/services" className="inline-block px-6 py-3 bg-[#1a2542] hover:bg-[#233055] text-white rounded-md transition-colors duration-300 font-medium" data-id="element-180">
              View All Services
            </Link>
          </div>
        </div>
      </section>
      {/* CTA Section */}
      <section className="py-16 md:py-20 bg-[#1a2542] text-white" data-id="element-181">
        <div className="container mx-auto px-4" data-id="element-182">
          <div className="max-w-3xl mx-auto text-center" data-id="element-183">
            <h2 className="text-2xl md:text-3xl font-serif mb-6" data-id="element-184">
              Ready to Work with The Concierge Lawyering?
            </h2>
            <p className="text-lg text-gray-200 mb-8" data-id="element-185">
              Whether you are exploring opportunities, resolving a transaction,
              or expanding across borders, our team is ready to support you.
            </p>
            <Link to="/contact" className="inline-block px-8 py-3 bg-[#c8a951] hover:bg-[#b39745] text-white rounded-md transition-colors duration-300 font-medium" data-id="element-186">
              Contact Us Today
            </Link>
          </div>
        </div>
      </section>
    </div>;
};
export default Home;